import { useLazyLoadQuery } from 'react-relay'
import { graphql } from 'relay-runtime'
import { FormValue } from 'types'
import SelectField from 'components/SelectField'
import { MenuItem } from '@mui/material'
import { CSSProperties, memo, useMemo } from 'react'
import { SelectCurrencies_Query } from '__generated__/SelectCurrencies_Query.graphql'
import { arrayFilterNonNullable } from 'services/array'

interface ISelectCurrenciesProps {
  currency: FormValue<string>
  style?: CSSProperties
}

function SelectCurrencies({ currency, style }: ISelectCurrenciesProps) {
  const data = useLazyLoadQuery<SelectCurrencies_Query>(graphql`
    query SelectCurrencies_Query {
      currencies(allowContracts: true) {
        code
      }
    }
  `, {}, {
    fetchPolicy: 'store-and-network',
  })

  const currencies = useMemo<string[]>(() => {
    let value = [...(data?.currencies?.map(c => c?.code)?.filter(arrayFilterNonNullable) || [])]
    if (currency.input.value && !value.find(c => c === currency.input.value)) {
      value.push(currency.input.value)
    }
    if (!value?.length) value = ['USD']
    return value
  }, [data, currency.input.value])

  const disabled = currencies.length < 2

  return (
    <SelectField
      label="Cur."
      name="currency"
      input={currency.input}
      meta={currency.meta}
      disabled={disabled}
      style={style}
    >
      {currencies.map(v => (
        <MenuItem
          key={v}
          value={v}
        >
          {v}
        </MenuItem>
      ))}
    </SelectField>
  )
}

export default memo(SelectCurrencies)
